<template>
  <div id="voting" class="call-to-action">
    <b-card class="rounded-0" overlay bg-variant="transparent" :img-src="image" alt="USA Flag">
      <div class="caption">
        <div class="content p-1">
          <p body-text-variant="primary">
            <b><h1>{{ title }}</h1><br />{{ description }} <br />{{ information }}</b><br />{{ information2 }}<br /><b-button variant="primary" target="_Blank" href='https://www.miamidade.gov/global/elections/home.page'>UPCOMING ELECTIONS</b-button>
          </p>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "CallToAction",
  props: ["image", "title", "description", "information", "information2", "button"],
};
</script>

<style lang="scss" scoped>
.caption {
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  object-fit: cover;
  font-size: 1.5em;

  .h1{
    font-size: 5em;
  }
  .content {
    background-color: rgba(236, 234, 250, 0.829);
  }
  @media screen and (max-width: 1000px) {
    h1
    {
      font-size:small;
      font-weight: bold;
      padding: 0px;
      margin:0px;
    }
    p
    {
      font-size:40%;
      padding: 0px;
      margin:0px;
    }

  }
}
</style>